/** @fileoverview Gateway paths for Fabrik data queries, kept together so a backend route change is made in one place. */

/*
 * The builder and hosted apps run the same Fabrik query with the same body, through two gateway routes:
 * the builder route takes the platform login, the app-runtime route takes only the app pass.
 */

/** Path of the builder's data query for one system. */
export const getBuilderQueryPath = (systemId: string) =>
  `/app/fabrik/runtime/${encodeURIComponent(systemId)}/query`;

/** Path of the builder's Workday read for one Workday system. */
export const getBuilderWorkdayQueryPath = (systemId: string) =>
  `/app/fabrik/runtime/${encodeURIComponent(systemId)}/workday-query`;

/** Path of the builder's field options (picklist values, foundation object records) for one system. */
export const getBuilderFieldOptionsPath = (systemId: string) =>
  `/app/fabrik/runtime/${encodeURIComponent(systemId)}/field-options`;

/** Path of the builder's search and label lookup of one system field's values. */
export const getBuilderFieldValuesPath = (systemId: string) =>
  `/app/fabrik/runtime/${encodeURIComponent(systemId)}/field-values`;

/** Path of a hosted app's field options for one system. */
export const getAppRuntimeFieldOptionsPath = (systemId: string) =>
  `/app/fabrik/app-runtime/${encodeURIComponent(systemId)}/field-options`;

/** Path of a hosted app's search and label lookup of one system field's values. */
export const getAppRuntimeFieldValuesPath = (systemId: string) =>
  `/app/fabrik/app-runtime/${encodeURIComponent(systemId)}/field-values`;

/** Path of a hosted app's data query for one system. */
export const getAppRuntimeQueryPath = (systemId: string) =>
  `/app/fabrik/app-runtime/${encodeURIComponent(systemId)}/query`;

/** Path of a hosted app's Workday read for one Workday system. */
export const getAppRuntimeWorkdayQueryPath = (systemId: string) =>
  `/app/fabrik/app-runtime/${encodeURIComponent(systemId)}/workday-query`;

/*
 * Checklist and timeline rows ("component state") also have two routes: the builder route works on
 * the draft for one app id, the app-runtime route works on the app named by the app pass.
 * Both take the same relative paths, see makeComponentStateApi.
 */

/** Base path of the hosted app routes for checklist and timeline rows and actions. */
export const getAppRuntimeBasePath = () => '/app/fabrik/app-runtime';

/**
 * Base path of the builder preview routes for checklist and timeline rows and actions.
 * @param appId id of the app
 */
export const getBuilderRuntimeBasePath = (appId: string) =>
  `/app/fabrik/apps/${encodeURIComponent(appId)}/runtime`;
